import React, { Component } from "react";
import classnames from "classnames";

import { combineFilters } from "@formant/core/common/combineFilters";
import { IFilter } from "@formant/core/model/IFilter";

import { observeStore, streamStore } from "../../stores";
import * as styles from "./ModuleSeek.scss";
import { SeekButton } from "./SeekButton";

export interface IModuleSeekProps {
    filter: IFilter;
    streamName: string;
    onSeek: (time: Date) => void;
}

export class ModuleSeek extends Component<IModuleSeekProps> {
    public render() {
        const { filter, streamName, onSeek } = this.props;
        const { mode } = observeStore;
        const { streamNameTypeMap } = streamStore;

        const hasData = streamNameTypeMap?.has(streamName);

        const combinedFilter = combineFilters(filter, {
            names: [streamName],
        });

        if (!hasData) {
            return (
                <div
                    className={classnames(
                        styles["module-seek"],
                        mode === "live" ? styles.live : null,
                        styles["no-data"],
                    )}
                    data-testid="module-seek"
                >
                    No Data
                </div>
            );
        }

        return (
            <div
                className={classnames(
                    styles["module-seek"],
                    mode === "live" ? styles.live : null,
                )}
                data-testid="module-seek"
            >
                <SeekButton
                    direction="previous"
                    filter={combinedFilter}
                    lighter={true}
                    className={styles["seek-previous"]}
                    onSeek={onSeek}
                    seekOption="Data presence"
                    label="Seek to previous data point"
                />
                Seek
                {mode !== "live" && (
                    <SeekButton
                        direction="next"
                        filter={combinedFilter}
                        lighter={true}
                        className={styles["seek-next"]}
                        onSeek={onSeek}
                        seekOption="Data presence"
                        label="Seek to next data point"
                    />
                )}
            </div>
        );
    }
}
